import React from 'react';
import Account from '../components/Account/Account';

const AccountPage: React.FC = () => {
    return (
        <div>
            <Account />
        </div>
    );
};

export default AccountPage;
